import React from "react";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { useCookieConsent } from "./CookieConsentProvider";
import { useTranslation } from "../hooks/useTranslation";

export default function CookieBanner() {
  const { t } = useTranslation();
  const {
    shouldShowBanner,
    acceptAll,
    rejectNonEssential,
    openCookieSettings,
  } = useCookieConsent();

  if (!shouldShowBanner) return null;

  return (
    <Paper
      role="region"
      aria-label="Cookie consent"
      elevation={10}
      sx={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: (theme) => theme.zIndex.modal - 1,
        borderTop: "1px solid rgba(0,0,0,0.12)",
      }}
    >
      <Box
        sx={{
          px: { xs: 2, sm: 3 },
          py: { xs: 2, sm: 2.5 },
          maxWidth: 1200,
          mx: "auto",
        }}
      >
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={2}
          alignItems={{ xs: "stretch", md: "center" }}
          justifyContent="space-between"
        >
          <Box sx={{ pr: { md: 2 } }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              {t('cookieBannerTitle')}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t('cookieBannerBody')}
            </Typography>
          </Box>

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1}
            sx={{ flexShrink: 0 }}
          >
            <Button variant="contained" onClick={acceptAll}>
              {t('acceptAll')}
            </Button>
            <Button variant="outlined" onClick={rejectNonEssential}>
              {t('rejectNonEssential')}
            </Button>
            <Button variant="text" onClick={openCookieSettings}>
              {t('customize')}
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Paper>
  );
}
